// assets/hero-slider.js
(() => {
  function init(root) {
    const slidesWrap = root.querySelector('[data-slides]');
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const dotsWrap = root.querySelector('[data-dots]');
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const effect = root.dataset.effect || 'fade';
    const loop = root.dataset.loop === 'true';
    const autoplay = root.dataset.autoplay === 'true';
    const pauseOnHover = root.dataset.pause === 'true';
    const showDots = root.dataset.showDots === 'true';
    const interval = parseInt(root.dataset.interval || '5000', 10);
    const speed = parseInt(root.dataset.speed || '500', 10);
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // CSS speed var
    slidesWrap.style.setProperty('--speed', `${speed}ms`);
    slidesWrap.dataset.effect = effect;

    let index = 0;
    let timer = null;

    // Build dots
    if (dotsWrap && slides.length > 1 && showDots !== false) {
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Go to slide ${i + 1}`);
        b.addEventListener('click', () => go(i, true));
        dotsWrap.appendChild(b);
      });
    }

    function updateDots() {
      if (!dotsWrap) return;
      const bs = dotsWrap.querySelectorAll('button');
      bs.forEach((b, i) => b.setAttribute('aria-current', String(i === index)));
    }

    function updateAria() {
      slides.forEach((s, i) => s.setAttribute('aria-hidden', String(i !== index)));
    }

    function go(to, userInitiated = false) {
      if (to === index) return;
      if (to < 0) to = loop ? slides.length - 1 : 0;
      if (to > slides.length - 1) to = loop ? 0 : slides.length - 1;

      if (effect === 'slide') {
        slidesWrap.style.transform = `translateX(-${to * 100}%)`;
        slides[index].classList.remove('is-active');
        slides[to].classList.add('is-active');
      } else {
        slides[index].classList.remove('is-active');
        slides[to].classList.add('is-active');
      }
      index = to;
      updateDots();
      updateAria();
      if (userInitiated) restartAutoplay();
      updateNavState();
    }

    function nextSlide(user) { go(index + 1, user); }
    function prevSlide(user) { go(index - 1, user); }

    function startAutoplay() {
      if (!autoplay || reduceMotion || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(() => {
        if (!loop && index === slides.length - 1) {
          stopAutoplay();
        } else {
          nextSlide(false);
        }
      }, interval);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }

    function updateNavState() {
      if (!prev || !next) return;
      if (loop) {
        prev.removeAttribute('disabled');
        next.removeAttribute('disabled');
      } else {
        prev.toggleAttribute('disabled', index === 0);
        next.toggleAttribute('disabled', index === slides.length - 1);
      }
    }

    // arrows
    prev && prev.addEventListener('click', () => prevSlide(true));
    next && next.addEventListener('click', () => nextSlide(true));

    // pause on hover
    if (pauseOnHover) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
    }

    // keyboard
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); prevSlide(true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); nextSlide(true); }
    });

    // swipe (basic)
    let x0 = null;
    root.addEventListener('touchstart', (e) => x0 = e.touches[0].clientX, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 == null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx > 0 ? prevSlide(true) : nextSlide(true); }
      x0 = null;
    }, { passive: true });

    // init states
    slides[0] && slides[0].classList.add('is-active');
    if (effect === 'slide') slidesWrap.style.transform = 'translateX(0%)';
    updateDots();
    updateAria();
    updateNavState();
    startAutoplay();
  }

  function mountAll() {
    document.querySelectorAll('[data-hero-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();